// API base URL support for admin frontend
const API_BASE = ((import.meta.env as any)?.VITE_ADMIN_API_BASE || '').toString().replace(/\/$/, '');
export const apiUrl = (path: string): string => `${API_BASE}${path}`;
